type ApplicationKey =
  | "AP_MIS_Online"
  | "CyberSource_Form"
  | "FormFinance"
  | "GSAP_Form"
  | "LocalPCAdminException_Form"
  | "MIGSMerchantManagerOperationPrivilege_Form"
  | "Removable_Media_Exception_Authorization_Form"
  | "risknet_form"
  | "Salesforce_Form"
  | "shareddrive_form"
  | "FormThirdParty"
  | "UPOP_Acquirer_Portal_Operator_Privilege_Form"
  | "FormWinscp"
  | "Workday";

export function getAdditionalFormKeyFromApplication(
  applicationKey: string | undefined
) {
  switch (applicationKey) {
    case "AP_MIS_Online":
      return "apMisOnline";
    case "CyberSource_Form":
      return "cyberSourceForm";
    case "FormFinance":
      return "formFinance";
    case "GSAP_Form":
      return "gsapForm";
    case "LocalPCAdminException_Form":
      return "localPCAdminExceptionForm";
    case "MIGSMerchantManagerOperationPrivilege_Form":
      return "migs";
    case "Removable_Media_Exception_Authorization_Form":
      return "removableMediaExceptionAuthorization";
    case "risknet_form":
      return "risknetForm";
    case "Salesforce_Form":
      return "salesforceForm";
    case "shareddrive_form":
      return "sharedDriveForm";
    case "FormThirdParty":
      return "formThirdParty";
    case "UPOP_Acquirer_Portal_Operator_Privilege_Form":
      return "upopAcquirerPortalOperatorPrivilegeForm";
    case "FormWinscp":
      return "formWinscp";
    case "Workday":
      return "workday";
    default:
      return undefined;
  }
}
